(function() {
  const config = window.DB7_CONFIG || {};
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || config.root || '/';
  const moneyLocale = config.locale || 'de';
  const moneyCurrency = config.currency || 'EUR';
  const isEnglish = Boolean(config.isEnglish);
  const freeShippingThresholds = { EUR: 2000, GBP: 2000, PLN: 10000 };
  const copy = Object.assign({
    emptyCart: isEnglish ? 'Your cart is empty.' : 'Ihr Warenkorb ist leer.',
    freeShippingFrom: isEnglish ? 'Free shipping from {amount}' : 'Kostenloser Versand ab {amount}',
    freeShippingMore: isEnglish ? 'Only {amount} away from free shipping 🎁' : 'Nur noch {amount} bis zum gratis Versand 🎁',
    freeShippingDone: isEnglish ? 'You get free shipping!' : 'Sie erhalten kostenlosen Versand!',
    quantity: isEnglish ? 'Quantity' : 'Menge',
    decreaseQty: isEnglish ? 'Decrease quantity' : 'Menge reduzieren',
    increaseQty: isEnglish ? 'Increase quantity' : 'Menge erhöhen',
    removeItem: isEnglish ? 'Remove' : 'Entfernen',
    productFallback: isEnglish ? 'DinaBase7 Denture Adhesive Gel' : 'DinaBase7 Zahnprothesen Haftgel',
    perDayPrefix: isEnglish ? 'Only ' : 'Nur ',
    perDaySuffix: isEnglish ? ' per day' : ' pro Tag',
    taxShipping: isEnglish ? 'incl. VAT' : 'inkl. MwSt.',
    plusShipping: isEnglish ? ' · plus shipping' : ' · zzgl. Versand',
    videoPlay: isEnglish ? 'Play video' : 'Video abspielen',
    videoPause: isEnglish ? 'Pause video' : 'Video pausieren',
    showLess: isEnglish ? 'Show less' : 'Weniger anzeigen',
    showAllSteps: isEnglish ? 'Show all 10 steps' : 'Alle 10 Schritte anzeigen',
    readMore: isEnglish ? 'Read more' : 'Weiter lesen',
    loading: isEnglish ? 'Loading...' : 'Wird geladen...',
    newsletterSubmitting: '...',
    newsletterSuccess: isEnglish ? 'Please confirm your subscription in the email we sent you.' : 'Bitte bestätigen Sie Ihre Anmeldung in der E-Mail, die wir Ihnen geschickt haben.',
    newsletterError: isEnglish ? 'Signup failed. Please try again.' : 'Fehler beim Anmelden. Bitte versuchen Sie es erneut.'
  }, config.copy || {});
  const fmtMoney = cents => new Intl.NumberFormat(moneyLocale || 'de-DE', { style: 'currency', currency: moneyCurrency || 'EUR' }).format((Number(cents || 0) / 100));
  const fmtShippingMoney = cents => new Intl.NumberFormat(moneyLocale || 'de-DE', { style: 'currency', currency: moneyCurrency || 'EUR', minimumFractionDigits: Number(cents || 0) % 100 === 0 ? 0 : 2, maximumFractionDigits: 2 }).format((Number(cents || 0) / 100));
  const freeShippingThreshold = cart => freeShippingThresholds[String((cart && cart.currency) || moneyCurrency || '').toUpperCase()] || 2000;
  const q = (sel, ctx=document) => ctx.querySelector(sel);
  const qa = (sel, ctx=document) => Array.from(ctx.querySelectorAll(sel));
  const escapeHTML = value => String(value || '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
  const localizedProductTitle = title => (isEnglish && /Zahnprothesen|Haftgel/.test(String(title || ''))) ? copy.productFallback : title;
  qa('.rating[data-review-rating]').forEach(rating => {
    const value = Number(rating.dataset.reviewRating || 0);
    const count = Number(rating.dataset.reviewCount || 0);
    const valueEl = q('[data-rating-value]', rating);
    const countEl = q('[data-rating-count]', rating);
    rating.style.setProperty('--rating-pct', Math.max(0, Math.min(100, value * 20)) + '%');
    if (valueEl) valueEl.textContent = value.toLocaleString(moneyLocale || (isEnglish ? 'en-GB' : 'de-DE'), { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    if (countEl) countEl.textContent = count.toLocaleString(moneyLocale || (isEnglish ? 'en-GB' : 'de-DE'));
  });
  const locWrap = q('#loc-wrap');
  const locBtn = q('.loc-btn', locWrap || document);
  if (locWrap && locBtn) {
    locBtn.addEventListener('click', e => { e.stopPropagation(); const open = locWrap.classList.toggle('open'); locBtn.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    document.addEventListener('click', e => { if (!locWrap.contains(e.target)) { locWrap.classList.remove('open'); locBtn.setAttribute('aria-expanded', 'false'); } });
  }
  const footerLoc = q('#footerLocWrap'); const footerBtn = q('#footerLocBtn');
  if (footerLoc && footerBtn) {
    footerBtn.addEventListener('click', e => { e.stopPropagation(); const open = footerLoc.classList.toggle('open'); footerBtn.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    document.addEventListener('click', e => { if (!footerLoc.contains(e.target)) { footerLoc.classList.remove('open'); footerBtn.setAttribute('aria-expanded', 'false'); } });
  }
  const mobileLoc = q('#mobileLocWrap'); const mobileLocBtn = q('#mobileLocBtn');
  if (mobileLoc && mobileLocBtn) {
    mobileLocBtn.addEventListener('click', e => { e.stopPropagation(); const open = mobileLoc.classList.toggle('open'); mobileLocBtn.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    document.addEventListener('click', e => { if (!mobileLoc.contains(e.target)) { mobileLoc.classList.remove('open'); mobileLocBtn.setAttribute('aria-expanded', 'false'); } });
  }
  qa('form.localization-form').forEach(form => {
    form.addEventListener('submit', () => {
      if (!/[?&]preview_theme_id=/.test(window.location.search)) return;
      let input = q('input[name="return_to"]', form);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'return_to';
        form.appendChild(input);
      }
      input.value = window.location.pathname + window.location.search;
    });
  });

  const klaviyoCompanyId = 'VLRxKy';
  const klaviyoNewsletterListId = 'XDqs56';
  const newsletterSource = 'Arando footer newsletter';
  function showNewsletterSuccess(form, replace) {
    const existing = q('.footer-nl-success', form);
    if (existing && !replace) return;
    const success = document.createElement('p');
    success.className = 'footer-nl-success';
    success.textContent = copy.newsletterSuccess;
    if (replace) {
      form.classList.add('is-submitted');
      form.innerHTML = '';
      form.appendChild(success);
    } else {
      form.appendChild(success);
    }
  }
  function showNewsletterError(form, submitBtn, originalLabel) {
    if (submitBtn) {
      submitBtn.textContent = originalLabel;
      submitBtn.disabled = false;
      submitBtn.style.pointerEvents = '';
      submitBtn.removeAttribute('aria-disabled');
    }
    const error = document.createElement('p');
    error.className = 'footer-nl-error';
    error.textContent = copy.newsletterError;
    form.appendChild(error);
  }
  function buildKlaviyoSubscription(email, form) {
    const profileAttributes = buildKlaviyoProfileAttributes(email);
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: newsletterSource,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                ...profileAttributes,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED'
                    }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: form.dataset.klaviyoListId || klaviyoNewsletterListId
            }
          }
        }
      }
    };
  }
  function buildKlaviyoProfileAttributes(email) {
    return {
      email: email,
      locale: navigator.language || moneyLocale || (isEnglish ? 'en' : 'de'),
      properties: {
        source: newsletterSource,
        shopify_view: window.location.pathname,
        page_url: window.location.href
      }
    };
  }
  function buildKlaviyoProfile(email) {
    return {
      data: {
        type: 'profile',
        attributes: buildKlaviyoProfileAttributes(email)
      }
    };
  }
  async function handleNewsletterSubmit(e) {
    const form = e.target && e.target.closest ? e.target.closest('.footer-nl-form') : null;
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (form.dataset.nlSubmitting === 'true') return;
    const emailInput = q('input[type="email"]', form);
    if (!emailInput || !emailInput.value.trim() || !emailInput.checkValidity()) {
      if (form.reportValidity) form.reportValidity();
      return;
    }
    const submitBtn = q('button[type="submit"]', form);
    const originalLabel = submitBtn ? submitBtn.textContent : '';
    const existingError = q('.footer-nl-error', form);
    if (existingError) existingError.remove();
    form.dataset.nlSubmitting = 'true';
    if (submitBtn) {
      submitBtn.textContent = copy.newsletterSubmitting;
      submitBtn.disabled = true;
    }
    try {
      const companyId = form.dataset.klaviyoCompanyId || klaviyoCompanyId;
      const klaviyoHeaders = {
        'Accept': 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
        'revision': '2026-04-15'
      };
      const email = emailInput.value.trim();
      const profileResponse = await fetch('https://a.klaviyo.com/client/profiles?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: klaviyoHeaders,
        body: JSON.stringify(buildKlaviyoProfile(email))
      });
      if (!profileResponse.ok) throw new Error('newsletter');
      const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: klaviyoHeaders,
        body: JSON.stringify(buildKlaviyoSubscription(email, form))
      });
      if (!response.ok) throw new Error('newsletter');
      showNewsletterSuccess(form, true);
    } catch (err) {
      form.dataset.nlSubmitting = 'false';
      showNewsletterError(form, submitBtn, originalLabel);
    }
  }
  window.addEventListener('submit', handleNewsletterSubmit, true);
  document.addEventListener('submit', handleNewsletterSubmit, true);

  const mobile = q('#MobileMenu'); const burger = q('.burger');
  function setMobile(open) {
    if (!mobile || !burger) return;
    if (open) mobile.removeAttribute('inert');
    mobile.classList.toggle('open', open);
    mobile.setAttribute('aria-hidden', open ? 'false' : 'true');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      const close = q('.mobile-menu__close', mobile);
      if (close) close.focus();
    } else {
      mobile.setAttribute('inert', '');
      const mobileLoc = q('#mobileLocWrap');
      const mobileLocBtn = q('#mobileLocBtn');
      if (mobileLoc) mobileLoc.classList.remove('open');
      if (mobileLocBtn) mobileLocBtn.setAttribute('aria-expanded', 'false');
    }
  }
  if (mobile && mobile.getAttribute('aria-hidden') === 'true') mobile.setAttribute('inert', '');
  if (burger) burger.addEventListener('click', () => setMobile(true));
  qa('[data-mobile-close]').forEach(el => el.addEventListener('click', () => setMobile(false)));
  if (mobile) {
    mobile.addEventListener('click', e => {
      if (!mobile.classList.contains('open')) return;
      if (e.target.closest('.mobile-menu__panel')) return;
      setMobile(false);
    });
  }

  const drawer = q(config.cartDrawerSelector || '#CartDrawer'); const cartButtons = qa('.action-cart');
  let drawerCloseTimer = 0;
  function lockScroll(open) {
    if (!drawer) return;
    drawer.dataset.scrollLocked = open ? 'true' : 'false';
  }
  function setDrawer(open) {
    if (!drawer) return;
    window.clearTimeout(drawerCloseTimer);
    if (open) drawer.removeAttribute('inert');
    drawer.classList.toggle('open', open);
    drawer.classList.remove('closing');
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    cartButtons.forEach(b => b.setAttribute('aria-expanded', open ? 'true' : 'false'));
    lockScroll(open);
    if (open) {
      return;
    }
    drawer.classList.add('closing');
    drawer.setAttribute('inert', '');
    drawerCloseTimer = window.setTimeout(() => drawer.classList.remove('closing'), 280);
  }
  if (drawer && drawer.getAttribute('aria-hidden') === 'true') drawer.setAttribute('inert', '');
  cartButtons.forEach(btn => btn.addEventListener('click', e => {
    e.preventDefault();
    setDrawer(true);
    refreshCart().catch(() => renderCart({ item_count: 0, total_price: 0, items: [] }));
  }));
  qa('[data-cart-close]').forEach(el => el.addEventListener('click', () => setDrawer(false)));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { setDrawer(false); setMobile(false); } });
  if (drawer) {
    drawer.addEventListener('click', e => {
      if (!drawer.classList.contains('open')) return;
      if (e.target === drawer || e.target.classList.contains('cart-drawer__overlay')) setDrawer(false);
    });
    drawer.addEventListener('wheel', e => {
      if (drawer.dataset.scrollLocked !== 'true') return;
      if (e.target.closest('.cart-drawer__body')) return;
      e.preventDefault();
    }, { passive: false });
    drawer.addEventListener('touchmove', e => {
      if (drawer.dataset.scrollLocked !== 'true') return;
      if (e.target.closest('.cart-drawer__body')) return;
      e.preventDefault();
    }, { passive: false });
  }

  function updateCounts(count) { qa('[data-cart-count]').forEach(el => el.textContent = count); }
  async function getCart() { const r = await fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }); if (!r.ok) throw new Error('cart'); return r.json(); }
  function renderShippingProgress(cart) {
    const threshold = freeShippingThreshold(cart);
    const total = Number(cart.total_price || 0);
    const remaining = Math.max(0, threshold - total);
    const pct = Math.min(100, Math.round((total / threshold) * 100));
    const shippingBox = q('#CartShippingProgress');
    const label = q('[data-cart-shipping-label]');
    const amount = q('[data-cart-shipping-amount]');
    const fill = q('[data-cart-shipping-fill]');
    if (shippingBox) shippingBox.classList.toggle('is-complete', remaining === 0);
    if (label) label.textContent = remaining > 0 ? copy.freeShippingMore.replace('{amount}', fmtShippingMoney(remaining)) : copy.freeShippingDone;
    if (amount) amount.textContent = '';
    if (fill) fill.style.width = pct + '%';
  }
  function getActiveGalleryImage() {
    const activeIdx = Math.max(0, qa('.gallery-thumbs img').findIndex(t => t.classList.contains('active')));
    return q(`.gallery-slide:nth-child(${activeIdx + 1}) img`) || q('.gallery-slide img');
  }
  function renderCartLineImage(item) {
    if (!item.image) return '<div class="cart-line__image cart-line__image--placeholder" aria-hidden="true"></div>';
    return `<img class="cart-line__image" src="${escapeHTML(item.image)}" alt="${escapeHTML(item.product_title)}" loading="lazy">`;
  }
  function renderCart(cart) {
    updateCounts(cart.item_count || 0);
    const items = drawer ? q('[data-db7-cart-items]', drawer) : q('#CartDrawerItems');
    const subtotal = drawer ? q('[data-db7-cart-subtotal]', drawer) : q('#CartDrawerSubtotal');
    const foot = drawer ? q('[data-db7-cart-foot]', drawer) : null;
    renderShippingProgress(cart);
    if (subtotal) subtotal.textContent = fmtMoney(cart.total_price);
    if (!items) return;
    if (foot) foot.hidden = !cart.items || !cart.items.length;
    if (!cart.items || !cart.items.length) { items.innerHTML = '<div class="cart-drawer__empty">' + copy.emptyCart + '</div>'; return; }
    items.innerHTML = cart.items.map(item => `
      <div class="cart-line" data-key="${item.key}">
        ${renderCartLineImage(item)}
        <div class="cart-line__main">
          <a class="cart-line__title" href="${escapeHTML(item.url || '#')}">${escapeHTML(item.product_title)}</a>
          <div class="cart-line__controls">
            <div class="cart-line__qty" aria-label="${copy.quantity}">
              <button class="qty-btn" data-cart-qty="${Math.max(0, Number(item.quantity) - 1)}" aria-label="${copy.decreaseQty}">−</button>
              <span class="cart-line__qty-value">${item.quantity}</span>
              <button class="qty-btn" data-cart-qty="${Number(item.quantity) + 1}" aria-label="${copy.increaseQty}">+</button>
            </div>
            <div class="cart-line__price">${fmtMoney(item.final_line_price)}</div>
          </div>
        </div>
        <button class="cart-line__remove" type="button" data-cart-remove aria-label="${copy.removeItem}">×</button>
      </div>`).join('');
    qa('[data-cart-qty]', items).forEach(btn => btn.addEventListener('click', async () => { const line = btn.closest('.cart-line'); await changeLine(line.dataset.key, Number(btn.dataset.cartQty)); }));
    qa('[data-cart-remove]', items).forEach(btn => btn.addEventListener('click', async () => { const line = btn.closest('.cart-line'); await changeLine(line.dataset.key, 0); }));
  }
  async function refreshCart() { const cart = await getCart(); renderCart(cart); return cart; }
  function renderOptimisticCart(data, quantity) {
    const price = Number(data.basePrice || 0) * Number(quantity || 1);
    renderCart({ item_count: Number(quantity || 1), total_price: price, items: [{
      key: 'db7-local',
      image: getActiveGalleryImage() ? getActiveGalleryImage().src : '',
      product_title: data.title || copy.productFallback,
      variant_title: 'Tube',
      quantity: Number(quantity || 1),
      final_line_price: price
    }] });
  }
  async function changeLine(id, quantity) { const r = await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id, quantity }) }); renderCart(await r.json()); }
  window.DB7Cart = { open: () => setDrawer(true), refresh: refreshCart, render: renderCart, formatMoney: fmtMoney };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => refreshCart().catch(() => {}));
  }

  const productDataEl = q('#db7ProductData');
  if (productDataEl) {
    const data = JSON.parse(productDataEl.textContent);
    const state = { option: 'onetime', qty: 1 };
    const discountCents = cents => Math.round(Number(cents) * 0.9);
    const priceCents = () => (state.option === 'subscribe' ? discountCents(data.basePrice) : Number(data.basePrice)) * state.qty;
    const days = () => 42 * state.qty;
    function setText(id, text) { const el = q('#' + id); if (el) el.textContent = text; }
    function syncProductForm() {
      const form = q('[data-db7-product-form]');
      if (!form) return;
      const variantInput = q('[data-db7-form-variant]', form);
      const quantityInput = q('[data-db7-form-quantity]', form);
      const sellingPlanInput = q('[data-db7-form-selling-plan]', form);
      const useSellingPlan = state.option === 'subscribe' && data.sellingPlanId;
      if (variantInput) variantInput.value = data.variantId;
      if (quantityInput) quantityInput.value = state.qty;
      if (sellingPlanInput) {
        sellingPlanInput.value = useSellingPlan ? data.sellingPlanId : '';
        sellingPlanInput.disabled = !useSellingPlan;
      }
    }
    function setActiveVariant(variant) {
      if (!variant) return;
      data.variantId = variant.id;
      data.basePrice = Number(variant.price);
      data.unitPrice = Number(variant.unitPrice || 0);
      data.unitRef = variant.unitRef || data.unitRef;
      data.available = Boolean(variant.available);
      data.sellingPlanId = variant.sellingPlanId || null;
      if (!data.sellingPlanId && state.option === 'subscribe') state.option = 'onetime';
    }
    function updateProductUi() {
      const onetime = Number(data.basePrice) * state.qty; const sub = discountCents(data.basePrice) * state.qty; const current = priceCents();
      setText('perday-pill', copy.perDayPrefix + fmtMoney(Math.round(current / days())) + copy.perDaySuffix);
      setText('price-current', fmtMoney(current));
      const old = q('#price-old'); if (old) { old.textContent = fmtMoney(onetime); old.style.display = state.option === 'subscribe' ? '' : 'none'; }
      const meta = q('#price-meta'); if (meta) meta.textContent = (data.unitPrice ? fmtMoney(data.unitPrice) + '/' + data.unitRef + ' · ' : '') + copy.taxShipping + copy.plusShipping;
      setText('onetime-price', fmtMoney(onetime));
	      const subEl = q('#sub-price'); if (subEl) subEl.innerHTML = '<s>' + fmtMoney(onetime) + '</s>' + fmtMoney(sub);
	      setText('cta-price', fmtMoney(current));
	      const perks = q('#opt-perks'); if (perks) perks.classList.toggle('show', state.option === 'subscribe');
      qa('[data-qty]').forEach(el => { const selected = Number(el.dataset.qty) === state.qty; el.classList.toggle('featured', selected); el.setAttribute('aria-pressed', selected ? 'true' : 'false'); q('.price-new', el).textContent = fmtMoney(Number(data.basePrice) * Number(el.dataset.qty)); });
      qa('[data-opt]').forEach(el => { const selected = el.dataset.opt === state.option; el.classList.toggle('selected', selected); el.setAttribute('aria-pressed', selected ? 'true' : 'false'); });
      const add = q('#cta-btn');
      if (add) add.disabled = !data.available;
      syncProductForm();
    }
    qa('[data-opt]').forEach(el => el.addEventListener('click', () => { state.option = el.dataset.opt; updateProductUi(); }));
    qa('[data-qty]').forEach(el => el.addEventListener('click', () => { state.qty = Number(el.dataset.qty); updateProductUi(); }));
    const variantSelect = q('[data-generic-variant-select]');
    if (variantSelect && Array.isArray(data.variants)) {
      variantSelect.addEventListener('change', () => {
        setActiveVariant(data.variants.find(variant => String(variant.id) === String(variantSelect.value)));
        updateProductUi();
      });
    }
    qa('[data-generic-variant-option]').forEach(btn => {
      btn.addEventListener('click', () => {
        setActiveVariant(data.variants.find(variant => String(variant.id) === String(btn.dataset.genericVariantOption)));
        qa('[data-generic-variant-option]').forEach(option => {
          const selected = option === btn;
          option.classList.toggle('selected', selected);
          option.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        updateProductUi();
      });
    });
    const genericQtyValue = q('[data-generic-qty-value]');
    function updateGenericQty(delta) {
      state.qty = Math.max(1, state.qty + delta);
      if (genericQtyValue) genericQtyValue.textContent = String(state.qty);
      updateProductUi();
    }
    q('[data-generic-qty-minus]')?.addEventListener('click', () => updateGenericQty(-1));
    q('[data-generic-qty-plus]')?.addEventListener('click', () => updateGenericQty(1));
    const add = q('#cta-btn');
    const productForm = q('[data-db7-product-form]');
    async function addSelectedToCart(event) {
      if (event) event.preventDefault();
      if (!add || add.disabled) return;
      add.disabled = true;
      const payload = { id: data.variantId, quantity: state.qty };
      if (state.option === 'subscribe' && data.sellingPlanId) payload.selling_plan = data.sellingPlanId;
      if (state.option === 'subscribe' && !data.sellingPlanId) payload.properties = { 'Kaufoption': 'Spar-Abo Auswahl' };
      try {
        const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) });
        if (!r.ok) throw new Error(await r.text());
        await refreshCart(); setDrawer(true);
      } catch (err) { console.error(err); renderOptimisticCart(data, state.qty); setDrawer(true); } finally { add.disabled = false; }
    }
    if (productForm) productForm.addEventListener('submit', addSelectedToCart);
    else if (add) add.addEventListener('click', addSelectedToCart);
	    updateProductUi();
	  }

	  const stickyAtc = q('#DB7StickyAtc');
	  const stickyBtn = q('[data-sticky-atc-scroll]');
	  const mainCta = q('#cta-btn');
	  const siteFooter = q('.site-footer');
	  let stickyCtaPassed = false;
	  let stickyFooterVisible = false;
	  function setStickyVisible(visible) {
	    if (!stickyAtc) return;
	    stickyAtc.classList.toggle('is-visible', Boolean(visible));
	    stickyAtc.setAttribute('aria-hidden', visible ? 'false' : 'true');
	    if (visible) stickyAtc.removeAttribute('inert');
	    else stickyAtc.setAttribute('inert', '');
	  }
	  function updateStickyAtc() {
	    setStickyVisible(stickyCtaPassed && !stickyFooterVisible);
	  }
	  function updateStickyFooterVisible() {
	    if (!siteFooter) {
	      stickyFooterVisible = false;
	      return;
	    }
	    const rect = siteFooter.getBoundingClientRect();
	    stickyFooterVisible = rect.top < window.innerHeight && rect.bottom > 0;
	  }
	  function checkStickyAtc() {
	    if (!mainCta) {
	      stickyCtaPassed = false;
	      return updateStickyAtc();
	    }
	    const rect = mainCta.getBoundingClientRect();
	    stickyCtaPassed = rect.bottom <= 0;
	    updateStickyAtc();
	  }
	  function checkStickyState() {
	    updateStickyFooterVisible();
	    checkStickyAtc();
	  }
	  if (stickyBtn) {
	    stickyBtn.addEventListener('click', () => {
	      if (window.matchMedia('(max-width: 768px)').matches) {
	        const title = q('h1.title');
	        if (title) title.scrollIntoView({ behavior: 'smooth', block: 'start' });
	        else window.scrollTo({ top: 0, behavior: 'smooth' });
	      } else {
	        window.scrollTo({ top: 0, behavior: 'smooth' });
	      }
	    });
	  }
	  if (stickyAtc && mainCta) {
	    if ('IntersectionObserver' in window) {
	      const stickyObserver = new IntersectionObserver(entries => {
	        const entry = entries[0];
	        const rect = entry.boundingClientRect;
	        stickyCtaPassed = !entry.isIntersecting && rect.bottom <= 0;
	        updateStickyAtc();
	      }, { threshold: 0 });
	      stickyObserver.observe(mainCta);
	      if (siteFooter) {
	        const stickyFooterObserver = new IntersectionObserver(entries => {
	          stickyFooterVisible = entries.some(entry => entry.isIntersecting);
	          updateStickyAtc();
	        }, { threshold: 0 });
	        stickyFooterObserver.observe(siteFooter);
	      }
	    }
	    window.addEventListener('scroll', checkStickyState, { passive: true });
	    window.addEventListener('resize', checkStickyState);
	    checkStickyState();
	  }

	  const galleryTrack = q('#GalleryTrack');
  function setActiveThumb(idx) {
    const thumbs = qa('.gallery-thumbs img');
    thumbs.forEach((t, i) => t.classList.toggle('active', i === idx));
    if (thumbs[idx]) thumbs[idx].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }
  function selectGallery(idx) {
    const slides = qa('.gallery-slide');
    if (!galleryTrack || !slides[idx]) return;
    slides[idx].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    setActiveThumb(idx);
  }
  qa('.gallery-thumbs img').forEach((img, idx) => img.addEventListener('click', () => selectGallery(idx)));
  if (galleryTrack) {
    let raf = 0;
    const syncGallery = () => {
      raf = 0;
      const idx = Math.round(galleryTrack.scrollLeft / Math.max(1, galleryTrack.clientWidth));
      setActiveThumb(Math.min(Math.max(idx, 0), qa('.gallery-slide').length - 1));
    };
    galleryTrack.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(syncGallery); }, { passive: true });
    galleryTrack.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') { e.preventDefault(); selectGallery(Math.min(qa('.gallery-slide').length - 1, Math.round(galleryTrack.scrollLeft / galleryTrack.clientWidth) + 1)); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); selectGallery(Math.max(0, Math.round(galleryTrack.scrollLeft / galleryTrack.clientWidth) - 1)); }
    });
    let dragging = false, dragStartX = 0, dragStartScroll = 0;
    galleryTrack.addEventListener('pointerdown', e => { if (e.pointerType === 'mouse' && e.button !== 0) return; dragging = true; dragStartX = e.clientX; dragStartScroll = galleryTrack.scrollLeft; galleryTrack.classList.add('dragging'); galleryTrack.setPointerCapture(e.pointerId); });
    galleryTrack.addEventListener('pointermove', e => { if (!dragging) return; galleryTrack.scrollLeft = dragStartScroll - (e.clientX - dragStartX); });
    const endDrag = e => { if (!dragging) return; dragging = false; galleryTrack.classList.remove('dragging'); try { galleryTrack.releasePointerCapture(e.pointerId); } catch (err) {} syncGallery(); };
    galleryTrack.addEventListener('pointerup', endDrag);
    galleryTrack.addEventListener('pointercancel', endDrag);
    q('[data-gallery-prev]')?.addEventListener('click', () => selectGallery(Math.max(0, Math.round(galleryTrack.scrollLeft / galleryTrack.clientWidth) - 1)));
    q('[data-gallery-next]')?.addEventListener('click', () => selectGallery(Math.min(qa('.gallery-slide').length - 1, Math.round(galleryTrack.scrollLeft / galleryTrack.clientWidth) + 1)));
  }

  const stepsGrid = q('#stepsGrid'), stepsFade = q('#stepsFade'), stepsBtn = q('#stepsToggle');
  if (stepsGrid && stepsBtn) stepsBtn.addEventListener('click', () => { const open = stepsGrid.classList.toggle('expanded'); stepsBtn.setAttribute('aria-expanded', open ? 'true' : 'false'); q('.steps-toggle-label', stepsBtn).textContent = open ? copy.showLess : copy.showAllSteps; if (stepsFade) stepsFade.style.opacity = open ? '0' : '1'; });
  const cmpBody = q('#comparisonBody'), cmpFade = q('#comparisonFade'), cmpBtn = q('#comparisonToggle');
  if (cmpBody && cmpBtn) cmpBtn.addEventListener('click', () => { const open = cmpBody.classList.toggle('expanded'); cmpBtn.setAttribute('aria-expanded', open ? 'true' : 'false'); q('.comparison-toggle-label', cmpBtn).textContent = open ? copy.showLess : copy.readMore; if (cmpFade) cmpFade.style.opacity = open ? '0' : '1'; });
  const videoFrame = q('.video-frame'), video = q('.video-frame video'), play = q('.video-play');
  if (video && play && videoFrame) {
    const toggle = q('[data-video-toggle]', videoFrame);
    const icon = q('[data-video-icon]', videoFrame);
    const progress = q('[data-video-progress]', videoFrame);
    const current = q('[data-video-current]', videoFrame);
    const duration = q('[data-video-duration]', videoFrame);
    const mute = q('[data-video-mute]', videoFrame);
    const volume = q('[data-video-volume]', videoFrame);
    const volumeIcon = q('[data-video-volume-icon]', videoFrame);
    const fullscreen = q('[data-video-fullscreen]', videoFrame);
    const speakerIcon = () => {
      if (video.muted || video.volume === 0) return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H3v6h3l5 4V5z"/><path d="M19 9l-6 6"/><path d="M13 9l6 6"/></svg>';
      if (video.volume < 0.55) return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H3v6h3l5 4V5z"/><path d="M15 10.5a4 4 0 0 1 0 3"/></svg>';
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H3v6h3l5 4V5z"/><path d="M15 8.5a6 6 0 0 1 0 7"/><path d="M18 5.5a10 10 0 0 1 0 13"/></svg>';
    };
    const fmtTime = seconds => {
      const value = Number.isFinite(seconds) ? Math.max(0, seconds) : 0;
      const mins = Math.floor(value / 60);
      const secs = Math.floor(value % 60).toString().padStart(2, '0');
      return mins + ':' + secs;
    };
    let controlsTimer = 0;
    const showControls = () => {
      videoFrame.classList.add('controls-visible');
      window.clearTimeout(controlsTimer);
      if (!video.paused) {
        controlsTimer = window.setTimeout(() => videoFrame.classList.remove('controls-visible'), 1000);
      }
    };
    const updateVideoUi = () => {
      videoFrame.classList.toggle('playing', !video.paused);
      videoFrame.classList.toggle('is-paused', video.paused);
      if (video.paused) {
        window.clearTimeout(controlsTimer);
        videoFrame.classList.add('controls-visible');
      }
      if (icon) icon.textContent = video.paused ? '▶' : 'Ⅱ';
      if (toggle) toggle.setAttribute('aria-label', video.paused ? copy.videoPlay : copy.videoPause);
      if (current) current.textContent = fmtTime(video.currentTime);
      if (duration) duration.textContent = fmtTime(video.duration);
    if (progress) {
      const pct = video.duration ? Math.round((video.currentTime / video.duration) * 1000) : 0;
      progress.value = String(pct);
      progress.style.setProperty('--video-progress', (pct / 10) + '%');
    }
      if (volumeIcon) volumeIcon.innerHTML = speakerIcon();
    };
    let videoSourcesLoaded = false;
    const loadVideoSources = () => {
      if (videoSourcesLoaded) return;
      qa('source[data-src]', video).forEach(source => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.preload = 'metadata';
      video.load();
      videoSourcesLoaded = true;
    };
    const togglePlay = () => {
      if (video.paused) {
        loadVideoSources();
        video.play();
      } else {
        video.pause();
      }
    };
    play.addEventListener('click', togglePlay);
    video.addEventListener('click', togglePlay);
    if (toggle) toggle.addEventListener('click', togglePlay);
    ['mousemove', 'mouseenter', 'touchstart', 'touchmove', 'pointermove'].forEach(evt => {
      videoFrame.addEventListener(evt, showControls, { passive: true });
    });
    video.addEventListener('play', () => { updateVideoUi(); showControls(); });
    video.addEventListener('pause', updateVideoUi);
    video.addEventListener('loadedmetadata', updateVideoUi);
    video.addEventListener('timeupdate', updateVideoUi);
    if (progress) progress.addEventListener('input', () => { showControls(); progress.style.setProperty('--video-progress', (Number(progress.value) / 10) + '%'); if (video.duration) video.currentTime = (Number(progress.value) / 1000) * video.duration; });
    if (volume) volume.addEventListener('input', () => { showControls(); video.volume = Number(volume.value); video.muted = video.volume === 0; updateVideoUi(); });
    if (mute) mute.addEventListener('click', () => { showControls(); video.muted = !video.muted; updateVideoUi(); });
    if (fullscreen) fullscreen.addEventListener('click', () => { showControls(); if (document.fullscreenElement) document.exitFullscreen(); else videoFrame.requestFullscreen?.(); });
    updateVideoUi();
  }
  refreshCart().catch(() => {});
})();
